/**
 *
 * Asynchronously loads the component for BillingActions Page
 *
 */

import { lazyLoad } from 'utils/loadable';

export const BillingActions = lazyLoad(
  () => import('./index'),
  module => module.BillingActionsPage,
);
